




































import FormField from '@/components/FormField'

export default {
    name: 'SelectField'

    extends: FormField
}
